module.exports = __webpack_public_path__ + "img/brand-ADS.32d02b58.png";